import { Modal } from '@acin/ui-core';
import React from 'react';
import { IInternalRegulationDocumentInstance } from '../../../graphql/generated';
import { useRegulation } from '../../RegulationProvider';
import { Documents } from './Documents';

interface DocumentsModalProps {
  regulationId: string;
}

export const DocumentsModal: React.FC<DocumentsModalProps> = ({ regulationId }) => {
  const { showDocumentModal, onUpdateShowDocumentModal, onUpdateActiveDocument, activeDocument } = useRegulation();
  const [selectedDocument, setSelectedDocument] = React.useState<IInternalRegulationDocumentInstance | undefined>(
    undefined,
  );

  // Document selection is required if there's no active document
  const isDocumentSelectionRequired = !activeDocument;

  const handleDocumentSelection = (document?: IInternalRegulationDocumentInstance) => {
    setSelectedDocument(document);
  };

  const handleConfirmDocumentSelection = () => {
    onUpdateActiveDocument(selectedDocument);
    onUpdateShowDocumentModal(false);
  };

  return (
    <Modal
      useScrollContent={false}
      customWidth={1200}
      show={showDocumentModal}
      title="Select a Document"
      stretchContent
      // Only allow dismiss if document selection is not required
      onClose={isDocumentSelectionRequired ? undefined : () => onUpdateShowDocumentModal(false)}
      footerButtonPrimary={{
        label: 'Update View',
        onClick: handleConfirmDocumentSelection,
        disabled: selectedDocument?.id === activeDocument?.id,
      }}
    >
      <Documents
        regulationId={regulationId}
        offerAllDocuments
        selectedDocument={selectedDocument}
        onSelectDocument={handleDocumentSelection}
      />
    </Modal>
  );
};
